import {Tab, TabProps} from '@mui/material'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import {ReactNode, useState} from 'react'
import {TabsLayoutStyled} from './TabsLayoutStyled'

type TabsLayoutProps = {
  tabs: TabProps[],
  contents: ReactNode[],
  onChange?: (index: number) => void,
  // Optional: which tab starts selected. Omitted by every caller but the ones that need to land
  // a user on a specific tab (e.g. deep-linked from elsewhere) — everyone else keeps today's "0".
  initialValue?: number
}

const TabsLayout: React.FC<TabsLayoutProps> = ({
  tabs,
  contents,
  onChange,
  initialValue
}) => {
  const [value, setValue] = useState(`${initialValue ?? 0}`)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(`${newValue}`)
    onChange?.(newValue)
  }

  return (
    <TabsLayoutStyled>
      <TabContext value={value}>
        <TabList
          allowScrollButtonsMobile
          onChange={handleChange}
          scrollButtons='auto'
          value={value}
          variant='scrollable'
        >
          {tabs.map((tab, index) => <Tab key={index} value={`${index}`} {...tab} />)}
        </TabList>
        {
          contents.map((content, index) => (
            <TabPanel key={index} value={`${index}`}>
              {content}
            </TabPanel>
          ))
        }
      </TabContext>
    </TabsLayoutStyled>
  )
}

export default TabsLayout
